/**
 * Created by Volvo on 17/9/7.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
  state:{

  },
  getters:{

  },
  mutations:{

  },
  actions:{

  },
  modules:{

  },
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/index.js